import { DateTime } from '../../../../themes/ett-core-theme/assets/scripts/vendors';
import { tns } from "../../../../themes/ett-core-theme/node_modules/tiny-slider/src/tiny-slider";
import { Calendar } from '../../../../themes/ett-core-theme/node_modules/@fullcalendar/core';
import dayGridPlugin from '../../../../themes/ett-core-theme/node_modules/@fullcalendar/daygrid';
import rrulePlugin from '../../../../themes/ett-core-theme/node_modules/@fullcalendar/rrule';
import itLocale from '../../../../themes/ett-core-theme/node_modules/@fullcalendar/core/locales/it';
// import bootstrapPlugin from '../../../../themes/ett-core-theme/node_modules/@fullcalendar/bootstrap';
import interactionPlugin from '../../../../themes/ett-core-theme/node_modules/@fullcalendar/interaction';
const ettCalendarBlock = (function ($, win) {
  var urlOrigin = win.location.origin;
  var loadinganimation = '';
  var loading = false;
  var lang;
  const isWpAdmin = document.querySelector('body').classList.contains('wp-admin');
  return {
    init: function (wrap) {
      let block;
      let calendarDom;
      let eventlistDom;
      let calendarArgs;
      if (wrap instanceof jQuery) {
        block = wrap.find(".content")[0];

      } else {
        block = wrap.querySelector(".content");
      }
      calendarDom = block.querySelector('.calendar');
      eventlistDom = block.querySelector('.event-list');
      calendarArgs = {
        calendar: calendarDom,
        terms: calendarDom.getAttribute('data-terms'),
        per_page: calendarDom.getAttribute('data-per_page'),
        post_type: calendarDom.getAttribute('data-post-type'),
      };
      ettCalendarBlock.currentBlock = block;
      ettCalendarBlock.calendarDom = calendarDom;
      ettCalendarBlock.eventlistDom = eventlistDom;
      const newCalendar = ettCalendarBlock.newFullCalendar(calendarArgs);
      ettCalendarBlock.firstGridInit(calendarArgs);
    },
    firstGridInit: function (calendarArgs) {
      var day = DateTime.local().startOf('day').toFormat('yyyy-LL-dd T');
      var dayEnd = DateTime.local().endOf('day').toFormat('yyyy-LL-dd T');
      var dayIndex = DateTime.local().weekday;
      lang = ettCalendarBlock.getCookie('wp-wpml_current_language');
      if (!lang) {
        lang = 'it';
      }
      ettCalendarBlock.getAjax(urlOrigin + '/wp-json/ett_api_get/v1/events?terms=' + calendarArgs.terms + '&type=ett_event&start=' + day + '&end=' + dayEnd + '&per_page=-1&lang=' + lang).then(function (data) {
        ettCalendarBlock.updateEventList(data, dayIndex);
      }).catch(function (er) {
        console.log(er);
      }).finally(function (end) {
        ettCalendarBlock.calendarDom.classList.remove('loading');
        loading = false;
      });
    },
    newSlider: function () {
      var slider = tns({
        container: ettCalendarBlock.eventlistDom,
        items: 2,
        gutter: 0,
        axis: 'vertical',
        controlsPosition: 'bottom',
        navPosition: 'bottom',
        controlsText: ['', ''],
        loop: false,
      });
      return slider;
    },
    generateDomBox: function (item) {
      var el = document.createElement('div');
      el.classList.add('grid-col');
      var img_thumb = item.images.thumbnail || { width: 150, height: 120, url: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP88B8AAuUB8e2ujYwAAAAASUVORK5CYII=" };
      var img_locandina = item.images.locandina;
      var img_large = item.images.large;
      if (img_locandina) {
        img_thumb = img_locandina;
      }
      var permanent = item.permanent;
      var url = item.custom_url || item.url || '';
      if (isWpAdmin) {
        url = false;
      }
      var start = item.start_Recur;
      var end = item.end_Recur;
      var end_hour = item.end_Hour;
      var showEnd = false;
      var startDate = '', endDate = '', s_time = '', s_date = '', s_month = '', s_year = '', e_date = '', e_month = '', e_year = '', s_hour = '', e_hour = '', e_time = '';
      var domTemplate = '';
      var shortCont = item.short_content || '';
      var trimWords = '';
      var shortSplit;
      var unid = ("grid-" + item.ID) + (DateTime.local().toFormat('x'));
      if (shortCont) {
        shortSplit = shortCont.split(" ");
        trimWords = shortSplit.slice(0, 15);
        trimWords = trimWords.join(" ");
      }
      if (start) {
        startDate = DateTime.fromSQL(start).setLocale('it');
        s_date = startDate.toFormat("cccc dd LLLL y");
        s_month = startDate.monthShort;
        s_year = startDate.toFormat("yyyy");
        s_hour = startDate.toFormat("HH");
        if (s_hour !== '00') {
          s_time = startDate.toFormat('T');
        }
        if (end_hour) {
          e_hour = DateTime.fromSQL(end_hour).toFormat("HH");
          if (e_hour !== '00') {
            e_time = DateTime.fromSQL(end_hour).setLocale('it').toFormat('T');
          }
        }
      }
      if (end) {
        endDate = DateTime.fromSQL(end).setLocale('it');
        e_date = endDate.toFormat("cccc dd LLLL");
        e_month = endDate.monthShort;
        e_year = endDate.toFormat("yyyy");
      }
      var diffD = endDate.diff(startDate, 'days').toObject();

      if (diffD && Math.round(diffD.days) > 0) {
        showEnd = true;
      }
      if (permanent) {
        showEnd = false;
      }
      var bgImage = '';
      if (img_thumb) {
        bgImage = 'style="background-image: url(' + img_thumb['url'] + ');"';
      }
      domTemplate = '<div class="event-item">';
      if (start) {
        domTemplate += '<div class="event-date-wr">';
        if (showEnd || permanent) {
          domTemplate += '<div>Da</div>';
        }
        domTemplate += '<div class="event-date">';
        domTemplate += '<span class="event-date_span">' + s_date + '</span>';
        domTemplate += '</div>';
        if (showEnd) {
          domTemplate += '<div class="event-date">';
          domTemplate += '<span class="event-date_span">a ' + e_date + '</span>';
          domTemplate += '</div>';
        } else if (permanent) {
          domTemplate += '<div><small> - evento permanente</small></div>';
        }
        domTemplate += '<div><span class="hour"></span>' + s_time + ' ' + e_time + '</div>';
        domTemplate += '</div>';
      }
      // domTemplate += '</div>';
      domTemplate += '<div class="event-content">';
      if (url === '#' || !url) {
        domTemplate += '<h2 class="h4 event-content-title"><span data-href="' + url + '"> ' + item.title + ' </span></h2>';
      } else {
        domTemplate += '<h2 class="h4 event-content-title"><a href="' + url + '" class="stretched-link"> ' + item.title + ' </a></h2>';
      }
      domTemplate += '</div>';
      domTemplate += '</div>';
      domTemplate += '</div>';
      el.innerHTML = domTemplate;
      return el;
    },
    appendToGrid: function (gridItems, calendarArgs) {
      ettCalendarBlock.eventlistDom.innerHTML = '';
      if (gridItems.length) {
        gridItems.forEach(function (element) {
          ettCalendarBlock.eventlistDom.appendChild(element);
        });
      } else {
        var emptyElement = document.createElement('div');
        emptyElement.classList.add('alert', 'alert-dark', 'col', 'm-2', 'w-100');
        emptyElement.innerHTML = 'Nessun evento in questa data';
        ettCalendarBlock.eventlistDom.appendChild(emptyElement);
      }
      return ettCalendarBlock.eventlistDom;
    },
    checkVisibility: function (item) {
      if (item.showInCalendar) {
        return true;
      }
      return false;
    },
    getAjax: function (url) {
      var promiseObj = new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.send();
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              var resp = xhr.responseText;
              var respJson = JSON.parse(resp);
              resolve(respJson);
            } else {
              reject(xhr.status);
            }
          } else {
            // console.log("loading ...");
          }
        }
      });
      return promiseObj;
    },
    getCookie: function (name) {
      var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
      return v ? v[2] : null;
    },
    setCookie: function (name, value, days) {
      var d = new Date;
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
      document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
    },
    updateEventList: function (data, dayIndex, dateEvent) {
      if (data.list) {
        let gridList = [];
        var today = DateTime.local().startOf('day').toFormat('yyyy-LL-dd T');
        if (dateEvent) {
          today = dateEvent.dateStr;
        }
        data.list.forEach(function (gridItem, index) {
          if (gridItem.showInCalendar === true) {
            var weekDayCheck = true;
            var newGridElement;
            var weekday_active = gridItem.weekday_active || null;
            if (weekday_active) {
              weekday_active = weekday_active.split(',');
              weekDayCheck = weekday_active.some(function (value) {
                return +(value) === dayIndex;
              });
            }
            if (gridItem.exdates.length) {
              if (gridItem.exdates.indexOf(today + " 00:00") >= 0) {
                return;
              }
            }
            if (weekDayCheck) {
              newGridElement = ettCalendarBlock.generateDomBox(gridItem);
              gridList.push(newGridElement);
            }
          }
        });
        ettCalendarBlock.appendToGrid(gridList);
      }
    },

    newFullCalendar: function (calendarArgs) {
      lang = ettCalendarBlock.getCookie('wp-wpml_current_language');
      if (!lang) {
        lang = 'it';
      }
      var fullCalendar = new Calendar(calendarArgs.calendar, {
        events: function (info, successCallback, failureCallback) {
          if (loading) {
            return false;
          }
          loading = true;
          let start = DateTime.fromISO(info.startStr).startOf('day').toFormat('yyyy-LL-dd T');
          let end = DateTime.fromISO(info.endStr).startOf('day').toFormat('yyyy-LL-dd T');
          ettCalendarBlock.calendarDom.classList.add('loading');
          return ettCalendarBlock.getAjax(urlOrigin + '/wp-json/ett_api_get/v1/events?terms=' + calendarArgs.terms + '&type=ett_event&start=' + start + '&end=' + end + '&per_page=-1&lang=' + lang).then(function (data) {
            if (data.list) {
              return data.list.filter(ettCalendarBlock.checkVisibility);
            }
          }).catch(function (error) {
          }).finally(function (end) {
            loading = false;
            ettCalendarBlock.calendarDom.classList.remove('loading');
          });
        },
        eventContent: function (event) {

        },
        eventSourceSuccess: function (content, xhr) {
          var mapDates = [];
          loading = false;
          if (content && content.length) {
            mapDates = content.map(function (element) {
              var start = DateTime.fromISO(element.start_Recur).startOf('day').toFormat('yyyy-LL-dd T');
              var end = DateTime.fromISO(element.end_Recur).endOf('day').toFormat('yyyy-LL-dd T');
              element.start_Recur = start;
              element.end_Recur = end;
              return element;
            });
            setTimeout(() => {

              ettCalendarBlock.calendarDom.classList.remove('loading');
            }, 500);
          }
          return mapDates;
        },
        eventSourceFailure: function (error) {
          console.error(error);
          loading = false;
        },
        eventClick: function (eventClickInfo) {
          eventClickInfo.jsEvent.preventDefault();
          eventClickInfo.jsEvent.stopImmediatePropagation();
          return false;
        },
        moreLinkClick: function (info) {
          info.jsEvent.preventDefault();
          return false;
        },

        dateClick: function (dateEvent) {
          if (loading) {
            return false;
          }
          var gridList = [];
          if (dateEvent.dayEl) {
            const dateStrLx = DateTime.fromISO(dateEvent.dateStr, { locale: 'it' });
            var dateClicked = dateStrLx.startOf('day').toFormat('yyyy-LL-dd T');
            var dateClickedEnd = dateStrLx.endOf('day').toFormat('yyyy-LL-dd T');
            var dayIndex = dateStrLx.weekday;
            lang = ettCalendarBlock.getCookie('wp-wpml_current_language');
            if (!lang) {
              lang = 'it';
            }
            var eventsUrl = urlOrigin + '/wp-json/ett_api_get/v1/events?terms=' + calendarArgs.terms + '&type=ett_event&start=' + dateClicked + '&end=' + dateClickedEnd + '&lang=' + lang + '&per_page=-1';
            loading = true;
            ettCalendarBlock.eventlistDom.innerHTML = ' caricamento ...';
            ettCalendarBlock.eventlistDom.classList.add('loading');
            ettCalendarBlock.getAjax(eventsUrl).then(function (data) {
              ettCalendarBlock.updateEventList(data, dayIndex, dateEvent);
              ettCalendarBlock.eventlistDom.classList.remove('loading');
            }).catch(function (error) {
              ettCalendarBlock.eventlistDom.innerHTML = '';
              gridList = [];
              ettCalendarBlock.appendToGrid([]);
            }).finally(function (end) {
              loading = false;
              ettCalendarBlock.eventlistDom.classList.remove('loading');
            });
            var calendarTable = ettCalendarBlock.currentBlock.querySelector('.fc-scrollgrid-sync-table');
            if (calendarTable) {
              let getDayGridEls = calendarTable.querySelectorAll('.fc-daygrid-day');
              if (getDayGridEls.length) {
                getDayGridEls.forEach(el => {
                  el.classList.remove('active-day-frame');
                });
              }
            }
            dateEvent.dayEl.classList.add('active-day-frame');
          }
        },
        eventDidMount: function (item) {
          var newEventTpl = '';
          if (item.hasOwnProperty('event')) {
            newEventTpl = `<span class="sr-only">Evento ${item.event.title}</span>`;
          } else {
            newEventTpl = `<span class="sr-only">Evento</span>`;
          }

          item.el.innerHTML = newEventTpl;
          return item;
        },
        dayMaxEventRows: 3,
        height: 'auto',
        eventColor: '#111111',
        lazyFetching: false,
        eventBackgroundColor: 'rgba(0,0,0,0.1)',
        eventBorderColor: '#222222',
        eventTextColor: '#111111',
        locale: itLocale,
        plugins: [dayGridPlugin, interactionPlugin, rrulePlugin],
        themeSystem: 'bootstrap',
        initialView: 'dayGridMonth',
        headerToolbar: {
          left: 'prev',
          center: 'title',
          right: 'next'
        }
      });
      fullCalendar.render();
      return fullCalendar;
    }
  };
})(jQuery, window);
{
  ettCalendarBlock.isAdmin = document.querySelector("body").classList.contains("wp-admin");
  const calendars = [...document.querySelectorAll(".calendarListWrapper")];
  if (calendars) {
    calendars.forEach((wrap) => {
      ettCalendarBlock.init(wrap);
    });
  }
}
(function ($) {
  if (window.acf) {
    window.acf.addAction(
      "render_block_preview/type=ett-calendar-block",
      ettCalendarBlock.init
    );
  }
})(jQuery);
export default ettCalendarBlock;

